// App.js
import React, { useContext, useEffect, useState } from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import AdminPanel from './AdminPanel/components/AdminPanel';
import { OperationsProvider } from "./AdminPanel/context/OperationsContext";
import { SlideProvider } from "./AdminPanel/context/SlideContext";
import { VideoProvider } from "./AdminPanel/context/VideoContext";
import { UserContext, UserProvider } from "./AdminPanel/context/UserContext";

import Header from "./components/Header";
import PriceTable from "./components/PriceTable";
import ForgotPassword from "./ForgotPassword";
import Login from "./Login";
import Signup from "./Signup";

const symbols = [
  "ONS",
  "USDTRY",
  "EURTRY",
  "EURUSD",
  "HAS",
  "YCEYREK",
  "YYARIM",
  "YZIYNET",
  "YATA",
  "ECEYREK",
  "EYARIM",
  "EZIYNET",
  "EATA",
  "UHAS",
  "18AYAR",
  "22AYAR",
  "14AYAR",
];

const App = () => {
  const [marqueeText, setMarqueeText] = useState("İSTANBUL KUYUMCULAR DERNEĞİ");
  const [scrollAmount, setScrollAmount] = useState(30);
  const [originalPrices, setOriginalPrices] = useState({});
  const [isStreamOn, setIsStreamOn] = useState(true);
  const [isFrozen, setIsFrozen] = useState(false);

  useEffect(() => {
    const fetchMarqueeSettings = async () => {
      try {
        // Production'da IIS reverse proxy kullan - /api istekleri otomatik olarak backend'e proxy ediliyor
        const apiUrl = '/api/marquee';
        const response = await fetch(apiUrl);
        if (response.ok) {
          const data = await response.json();
          if (data) {
            setMarqueeText(data.text);
            setScrollAmount(data.scroll_amount);
          }
        } else {
          console.error("Kayan yazı ayarlarını alma hatası:", response.statusText);
        }
      } catch (error) {
        console.error("Kayan yazı ayarlarını alma hatası:", error);
      }
    };

    fetchMarqueeSettings();

    const initialPrices = {};
    symbols.forEach((symbol) => {
      initialPrices[symbol] = { Bid: 0, Ask: 0 };
    });
    setOriginalPrices(initialPrices);
  }, []);

  const handleSaveMarqueeSettings = async (text, amount) => {
    try {
      // Production'da IIS reverse proxy kullan - /api istekleri otomatik olarak backend'e proxy ediliyor
      const apiUrl = '/api/marquee';
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ marqueeText: text, scrollAmount: amount }),
      });

      if (response.ok) {
        setMarqueeText(text);
        setScrollAmount(amount);
      } else {
        console.error("Kayan yazı ayarları kaydedilirken hata oluştu.");
      }
    } catch (error) {
      console.error("Kayan yazı ayarları kaydedilirken hata oluştu:", error);
    }
  };

  const handleTogglePrices = (isStreaming) => {
    setIsStreamOn(isStreaming);
  };

  const handleFreezePrices = (isFreezing) => {
    setIsFrozen(isFreezing);
  };

  return (
    <UserProvider>
      <SlideProvider>
        <VideoProvider>
        <OperationsProvider>
          <Router>
            <div
              className={
                window.location.pathname === "/login" ? "login-background" : "app-container"
              }
            >
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route
                  path="/"
                  element={
                    <PrivateRoute>
                      <Header />
                      <PriceTable
                        marqueeText={marqueeText}
                        scrollAmount={scrollAmount}
                        symbols={symbols}
                        originalPrices={originalPrices}
                        isStreamOn={isStreamOn}
                        isFrozen={isFrozen}
                      />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/Admin/*"
                  element={
                    <PrivateRoute>
                      <AdminPanel
                        marqueeText={marqueeText}
                        setMarqueeText={setMarqueeText}
                        scrollAmount={scrollAmount}
                        setScrollAmount={setScrollAmount}
                        onSaveMarqueeSettings={handleSaveMarqueeSettings}
                        symbols={symbols}
                        isStreamOn={isStreamOn}
                        isFrozen={isFrozen}
                        handleTogglePrices={handleTogglePrices}
                        handleFreezePrices={handleFreezePrices}
                      />
                    </PrivateRoute>
                  }
                />
              </Routes>
            </div>
          </Router>
        </OperationsProvider>
        </VideoProvider>
      </SlideProvider>
    </UserProvider>
  );
};

const PrivateRoute = ({ children }) => {
  const { currentUser } = useContext(UserContext);
  return currentUser ? children : <Navigate to="/login" />;
};

export default App;
